import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-full mb-4">
              <i className="ri-article-line" />
              资讯动态
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
              视频行业资讯
            </h2>
          </div>
          <Link
            to="/article/ai-video-trends"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
          >
            更多资讯
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-300 hover:shadow-lg transition-all duration-300"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-white/90 text-foreground-800 text-xs font-medium rounded-md backdrop-blur-sm">
                    {article.category}
                  </span>
                </div>
              </div>

              <div className="flex-1 p-4 md:p-5 flex flex-col">
                <h3 className="text-foreground-900 font-semibold text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm line-clamp-2 mb-4 flex-1 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400 pt-3 border-t border-background-200">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}